@use 'variables' as *;
@use 'mixins' as *;

$-padding: 1.25rem;

:host {
  display: block;
  border-radius: cat-border-radius('l');
  background-color: cat-token('color.ui.background.surface');
  padding: $-padding;
  @include cat-elevation-card;
}

:host([hidden]) {
  display: none;
}

::slotted(:last-child) {
  margin-bottom: 0 !important;
}

::slotted(nav),
::slotted(nav:last-child) {
  margin: #{0.25rem - $-padding} #{0.25rem - $-padding} !important;
}

// --- pull out helper classes

::slotted(.cat-card-pull) {
  margin: -$-padding !important;
  width: calc(100% + #{2 * $-padding}) !important;
  height: calc(100% + #{2 * $-padding}) !important;
}

::slotted(.cat-card-pull-h) {
  margin-left: -$-padding !important;
  margin-right: -$-padding !important;
  width: calc(100% + #{2 * $-padding}) !important;
}

::slotted(.cat-card-pull-v) {
  margin-top: -$-padding !important;
  margin-bottom: -$-padding !important;
  height: calc(100% + #{2 * $-padding}) !important;
}

::slotted(.cat-card-pull-t) {
  margin-top: -$-padding !important;
}

::slotted(.cat-card-pull-l) {
  margin-left: -$-padding !important;
}

::slotted(.cat-card-pull-r) {
  margin-right: -$-padding !important;
}

::slotted(.cat-card-pull-b) {
  margin-bottom: -$-padding !important;
}
